module.exports = __webpack_public_path__ + "static/media/gujranwala.171e6be9.svg";